
import { supabase } from "@/lib/supabase";

export const calculateDistance = (
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
): number => {
  const R = 6371e3; // Earth's radius in meters
  const φ1 = (lat1 * Math.PI) / 180;
  const φ2 = (lat2 * Math.PI) / 180;
  const Δφ = ((lat2 - lat1) * Math.PI) / 180;
  const Δλ = ((lon2 - lon1) * Math.PI) / 180;

  const a =
    Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c; // Distance in meters
};

export const checkGeofence = async (latitude: number, longitude: number): Promise<{ 
  isInside: boolean; 
  location: any; 
}> => {
  try {
    const { data: locations, error } = await supabase
      .from("work_locations")
      .select("*");

    if (error) throw error;

    let nearestLoc = null;
    let shortestDistance = Infinity;
    let isInside = false;

    for (const location of locations) {
      const distance = calculateDistance(
        latitude,
        longitude,
        location.latitude,
        location.longitude
      );

      if (distance < shortestDistance) {
        shortestDistance = distance;
        nearestLoc = location;
      }

      if (distance <= location.radius) {
        isInside = true;
        nearestLoc = location;
        break;
      }
    }

    return { isInside, location: nearestLoc };
  } catch (error) {
    console.error("Fejl ved geofence tjek:", error);
    return { isInside: false, location: null };
  }
};
